import { createActions, createReducer } from 'reduxsauce'
import _ from 'lodash'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  driverSegmentLoading: false,
  addingDriverSegment: false,
  driverSegments: {}
})

const { Types, Creators } = createActions({
  setDriverSegments: ['driverSegments'],
  setDriverSegment: ['driverSegmentId', 'data'],
  setDriverSegmentAdding: ['val'],
  setDriverSegmentLoading: ['val'],

  saveDriverSegment: ['id', 'data', 'callBack'],
  deleteDriverSegment: ['id', 'drivers'],
  syncDriverSegments: null
})

export const setDriverSegmentReducer = (state, { driverSegmentId, data }) =>
  state.setIn(
    ['driverSegments', driverSegmentId],
    state.driverSegments[driverSegmentId] ? { ...state.driverSegments[driverSegmentId], ...data } : data
  )

export const setDriverSegmentsReducer = (state, { driverSegments }) =>
  state.set('driverSegments', driverSegments).set('driverSegmentLoaded', true)

export const setDriverSegmentAddingReducer = (state, { val }) =>
  state.set('addingDriverSegment', val)

export const deleteDriverSegmentReducer = (state, { id }) =>
  state.set('driverSegments', _.omit(state.driverSegments, id))

export const setDriverSegmentLoadingReducer = (state, { val }) => state.set('driverSegmentLoading', val)

export const driverSegmentReducer = createReducer(INITIAL_STATE, {
  [Types.SET_DRIVER_SEGMENTS]: setDriverSegmentsReducer,
  [Types.SET_DRIVER_SEGMENT]: setDriverSegmentReducer,
  [Types.SET_DRIVER_SEGMENT_LOADING]: setDriverSegmentLoadingReducer,
  [Types.SET_DRIVER_SEGMENT_ADDING]: setDriverSegmentAddingReducer,
  [Types.DELETE_DRIVER_SEGMENT]: deleteDriverSegmentReducer,
})

export const DriverSegmentTypes = Types
export default Creators


// WEBPACK FOOTER //
// ./src/reducers/driverSegmentReducer.js